import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { MondayIcon, MondayIconBorderless, MondaySearchResultIcon } from './icon';

export const mondayConfig: ThirdPartyConfig = {
	displayName: 'Monday',
	id: 'monday',
	resourceType: ProductResourceTypes3P.Monday,
	icon: get3PLogo(MondayIcon, 'Monday', 'medium'),
	iconBorderless: get3PLogo(MondayIconBorderless, 'Monday', 'small'),
	searchResultIcon: get3PLogo(MondaySearchResultIcon, 'Monday', 'large'),
	integrationAri: 'ari:cloud:platform::integration/monday',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
